export default __webpack_public_path__ + "static/media/success.1512888c.png";